module.exports = __webpack_public_path__ + "static/media/nubuk.93fa6893.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/albums/nubuk.jpeg
// module id = 291
// module chunks = 0